import axios from 'axios'
import { DATAMASTER_ENDPOINT } from 'common/endpoints'

export async function getModels(brandId) {
    const result = await axios.get(DATAMASTER_ENDPOINT + `/brands/${brandId}/models`)
    return result;
}
